import { useState } from 'react'

function Taskbar({ tabs, activeTab, onTabChange, actions }) {
  const [isFullscreen, setIsFullscreen] = useState(false)

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen()
      setIsFullscreen(true)
    } else {
      document.exitFullscreen()
      setIsFullscreen(false)
    }
  }

  return (
    <div className="taskbar">
      <div className="taskbar-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`taskbar-tab fs-6${activeTab === tab.id ? ' taskbar-tab--active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
            {tab.sublabel && <span className="taskbar-tab-sublabel">{tab.sublabel}</span>}
          </button>
        ))}
      </div>
      <div className="taskbar-actions">
        {actions.map((action, i) => (
          <button
            key={i}
            className={`taskbar-action fs-6${action.active ? ' taskbar-action--active' : ''}`}
            onClick={action.onClick}
          >
            {action.label}
          </button>
        ))}
        <button className="taskbar-action fs-6" onClick={toggleFullscreen}>
          {isFullscreen ? '⊡' : '⛶'}
        </button>
      </div>
    </div>
  )
}

export default Taskbar
